import cn from 'clsx';
import { FC, ReactNode } from 'react';

import { Button } from '../../../../index';
import Icon from '../../../Icon';

import s from './Header.module.scss';

export interface HeaderProps {
  isTitleButton?: boolean;
  isCloseButton?: boolean;
  onClickTitleButton?: () => void;
  children?: ReactNode;
  onCloseDrawer: () => void;
}

const Header: FC<React.PropsWithChildren<React.PropsWithChildren<HeaderProps>>> = ({
  isTitleButton = false,
  isCloseButton = false,
  onClickTitleButton,
  onCloseDrawer,
  children
}) => {
  return (
    <div className={cn(s.header)}>
      {isTitleButton ? (
        <div className={cn(s.title_button)}>
          <Button.Text size="default" onClick={onClickTitleButton}>
            {children}
          </Button.Text>
        </div>
      ) : (
        <h1 className={cn(s.title_text)}>{children}</h1>
      )}
      {isCloseButton && (
        <button className={cn(s.close_btn)} type="button" aria-label="close" onClick={onCloseDrawer}>
          <div className={cn(s.close_icon_wrapper)}>
            <Icon type="close" size={24} color="gray.500" />
          </div>
        </button>
      )}
    </div>
  );
};

export default Header;
